import React, { Component } from 'react'
import moment from "moment";
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createD2hPublishMagazine,
  updateD2hPublishMagazine,
  getD2hPublishMagazine,
  deleteD2hPublishMagazine } from '../../../services/D2hPublishMagazineService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class D2hPublishMagazinePageView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      d2hpublishmagazineId: null,
      d2hpublishmagazine: null
    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    log.debug(this.props.match.params)
    // load info
    let d2hpublishmagazine = await getD2hPublishMagazine(this.props.match.params.id)
    log.debug(d2hpublishmagazine)

    log.debug('all data is loaded.')
    this.setState({d2hpublishmagazineId: this.props.match.params.id})
    this.setState({d2hpublishmagazine: d2hpublishmagazine})
    this.setState({isLoading: false})
  }

  async handleDelete(d2hpublishmagazineId, e) {
    e.preventDefault()
    log.debug(d2hpublishmagazineId)
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        try{
          await deleteD2hPublishMagazine(d2hpublishmagazineId)
          log.debug('delete success.')

          this.state.d2hpublishmagazine.status = 'D'
          this.setState({d2hpublishmagazine: this.state.d2hpublishmagazine})

          // redirect
          this.props.history.push(`/d2hpublishmagazine/`)

        }catch(err){
          log.debug(err)
          this.setState(setErrorMsg(err))
        }

    } else {
        log.debug('delete cancel')
    }
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/d2hpublishmagazine'>D2hPublishMagazine</Link> ->
          View
        </h4>
        <div className="panel panel-default">
    <div className="panel-heading">
        <Link className="btn btn-success" to={`/d2hpublishmagazine/edit/${this.state.d2hpublishmagazineId}`}>Edit</Link>
        &nbsp;
        <button
          type="button"
          onClick={(e) => this.handleDelete(this.state.d2hpublishmagazineId, e)}
          className="btn btn-small btn-danger">Delete</button>
    </div>
    {/* /.panel-heading */}
    <div className="panel-body">
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{width: '20%'}}>Name</th>
                        <th>value</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                      <td>d2hpublishmagazine_id</td>
                      <td>{this.state.d2hpublishmagazineId}</td>
                  </tr>

                    <tr>
                        <td>issue_id</td>
                        <td>{this.state.d2hpublishmagazine.issue_id}</td>
                    </tr>

                    <tr>
                        <td>issue_uuid</td>
                        <td>{this.state.d2hpublishmagazine.issue_uuid}</td>
                    </tr>

                    <tr>
                        <td>magazine_id</td>
                        <td>{this.state.d2hpublishmagazine.magazine_id}</td>
                    </tr>

                    <tr>
                        <td>magazine_uuid</td>
                        <td>{this.state.d2hpublishmagazine.magazine_uuid}</td>
                    </tr>

                    <tr>
                        <td>title</td>
                        <td>{this.state.d2hpublishmagazine.title}</td>
                    </tr>

                    <tr>
                        <td>description</td>
                        <td>{this.state.d2hpublishmagazine.description}</td>
                    </tr>

                    <tr>
                        <td>book_download_url</td>
                        <td>{this.state.d2hpublishmagazine.book_download_url}</td>
                    </tr>

                    <tr>
                        <td>download_success_msg_body</td>
                        <td>{this.state.d2hpublishmagazine.download_success_msg_body}</td>
                    </tr>

                    <tr>
                        <td>download_success_msg_title</td>
                        <td>{this.state.d2hpublishmagazine.download_success_msg_title}</td>
                    </tr>

                    <tr>
                        <td>notify_cover_number</td>
                        <td>{this.state.d2hpublishmagazine.notify_cover_number}</td>
                    </tr>

                    <tr>
                        <td>notify_when</td>
                        <td>{this.state.d2hpublishmagazine.notify_when}</td>
                    </tr>

                    {/* <tr>
                        <td>date_created</td>
                        <td>{this.state.d2hpublishmagazine.date_created}</td>
                    </tr> */}

                    <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.d2hpublishmagazine.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr>

                    <tr>
                        <td>status</td>
                        <td>{this.state.d2hpublishmagazine.status}</td>
                    </tr>


                    {/* <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.d2hpublishmagazine.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr> */}

                </tbody>
            </table>
        </div>
        {/* /.table-responsive */}
    </div>
    {/* /.panel-body */}
</div>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/D2hPublishMagazinePage/D2hPublishMagazinePageView.js